export const formatTime = (timeStamp: string | number) => {
  const time = new Date(Number(timeStamp) * 1000);
  const times =
    time.toLocaleDateString().replace(/\//g, "-") + " " + time.toTimeString().substr(0, 8);
  return times;
};
